<button mat-flat-button
        [color]="color"
        [disabled]="disabled"
>{{textKey | translate}} </button>
